import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { PermissionListComponent } from 'src/app/applicationModules/permission/components/permisionList/permission-list.component';
//import { PermissionService } from 'src/app/applicationModules/permission/services/permission/permission.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
@Component({
  selector: 'app-role-permissionss',
  templateUrl: './role-permissionss.component.html',
  styleUrls: ['./role-permissionss.component.scss']
})
export class RolePermissionssComponent implements OnInit {
  dataSource;
  ELEMENT_DATA: any[] = [];

  displayedColumns = [ 'Read', 'Write', 'Delete', 'Name', 'Description'];
  constructor(
    private dialogRef: MatDialogRef<RolePermissionssComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paginationVm: PaginationViewModel )
    {
      
    }

  ngOnInit(): void {
    this.paginationVm.pageIndex = 1;
    this.paginationVm.pageSize = 10;
    //this.ELEMENT_DATA = this.getPermissionData();
    this.dataSource = this.ELEMENT_DATA;
  }

  permissionResponseHolder: any;

  save(data) {
     
    this.dialogRef.close(data);
}

close() {
    this.dialogRef.close();
}

getPermissionData(){
  // let permList = [];
  // this.permissionService.getAllPermissions(this.paginationVm).subscribe(response=>{
  //   if (response != undefined) {
  //     this.permissionResponseHolder = response;
  //     permList = this.permissionResponseHolder.data;
  //   }    
  // });
  // return permList;
  
}


}
